<!-- 
 * @author song
 * @since 2022-04-21
 * @publisher  宏脉信息技术（广州）股份有限公司
 -->
<template>
  <div>
    <header style="display: flex;">
      <el-tag
        class="tree-input"
        title="选择员工"
        :closable="this.searchMenNames.length === 0 ? false : true"
        @close="searchCloseTag"
        type="medium"
        effect="plain"
        @click="clickAddMember(true)"
      >
        <span v-if="searchMenNames.length === 0">选择员工</span>
        <span v-for="(item, index) in searchMenNames" :key="index"
          >{{ item.name }}<span v-if="searchMenNames.length > 1">,</span></span
        >
      </el-tag>
      <el-button-group>
        <el-button size="mini" @click="getDataList">
          发送时间
        </el-button>
        <el-date-picker
          v-model="searchSelectTime"
          size="mini"
          type="daterange"
          :editable="false"
          value-format="yyyy-MM-dd "
          range-separator="~"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @change="selectTime"
          :clearable="false"
          style="width: 240px; margin-right: 10px"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
      </el-button-group>
    </header>
    <main>
      <el-table
        ref="tableData"
        :summary-method="getSummaries"
        :show-summary="true"
        :data="tableData"
        style="width: 100%"
        height="calc(100vh - 290px)"
        @sort-change="sortChange"
      >
        <el-table-column prop="userName" label="员工姓名" width="180">
        </el-table-column>
        <el-table-column
          prop="proSendTotal"
          label="商品发送次数"
          sortable="custom"
          width="180"
          :sort-orders="['descending', 'ascending', null]"
          :sort-method="sortMethod"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="salesClicks"
          label="商品点击次数"
          :sort-orders="['descending', 'ascending', null]"
          :sort-method="sortMethod"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="proClickRate"
          label="商品打开率"
          :sort-orders="['descending', 'ascending', null]"
          :sort-method="sortMethod"
        >
          <template slot-scope="scope">
            <!-- {{ scope.row }} -->
            {{ scope.row.proClickRate }}%
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="salesVolume"
          label="商品成交量"
          :sort-orders="['descending', 'ascending', null]"
          :sort-method="sortMethod"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="salesRate"
          label="商品成交率"
          :sort-orders="['descending', 'ascending', null]"
          :sort-method="sortMethod"
        >
          <template slot-scope="scope">
            <!-- {{ scope.row }} -->
            {{ scope.row.salesRate }}%
          </template>
        </el-table-column>
        <el-table-column
          prop="couSendTotal"
          label="券发送次数"
          sortable="custom"
          width="180"
          :sort-orders="['descending', 'ascending', null]"
          :sort-method="sortMethod"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="couponClicks"
          label="券点击次数"
          :sort-orders="['descending', 'ascending', null]"
          :sort-method="sortMethod"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="couClickRate"
          label="券打开率"
          :sort-orders="['descending', 'ascending', null]"
          :sort-method="sortMethod"
        >
          <template slot-scope="scope">
            <!-- {{ scope.row }} -->
            {{ scope.row.couClickRate }}%
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="couponClaimed"
          label="券领取数量"
          :sort-orders="['descending', 'ascending', null]"
          :sort-method="sortMethod"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="couponClaimRate"
          label="券领取率"
          :sort-orders="['descending', 'ascending', null]"
          :sort-method="sortMethod"
        >
          <template slot-scope="scope">
            <!-- {{ scope.row }} -->
            {{ scope.row.couponClaimRate }}%
          </template>
        </el-table-column>
      </el-table>
    </main>
    <footer>
      <Pagination
        v-bind:childMsg="pageparm"
        :pageSizes="pageSizes"
        @callBack="callBack"
      ></Pagination>
    </footer>
    <StaffTree
      :title="title"
      :dialogVisibleTree="dialogVisibleTree"
      :currentSelectMember="currentSelectMember"
      @closeTree="closeTree"
      @clickSubmitTree="clickSubmitTree"
    ></StaffTree>
  </div>
</template>

<script>
import { getEmpDataList } from "../../../api/contentCenter/Statistics";
import StaffTree from "@/components/staffTree/staffTree.vue";
import dayjs from "dayjs";
export default {
  name: "Employee",
  data() {
    return {
      formData: {
        userIds: [], //商品名称
        sortField: "", //排序字段  sendTotal-发送次数 clicks-点击次数 clickRate-打开率 salesVolume-商品成交量 couponClaimRate-商品成交率
        sortRule: "", //排序规则  asc-升序 desc-降序
        startTime: dayjs()
          .subtract(29, "days")
          .format("YYYY-MM-DD 00:00:00"), //开始时间
        endTime: dayjs()
          .subtract(0, "days")
          .format("YYYY-MM-DD 23:59:59"), //结束时间
        currentPage: 1, //当前页码
        pageSize: 10, //每页条数
      },
      searchSelectTime: [
        dayjs()
          .subtract(29, "days")
          .format("YYYY-MM-DD 00:00:00"),
        dayjs()
          .subtract(0, "days")
          .format("YYYY-MM-DD 23:59:59"),
      ],
      tableData: [
        // {
        //   clicks: "0", //点击数
        //   salesVolume: "0", //商品成交量
        //   salesRate: "0.00%", //商品成交率
        //   couponClaimed: "0", //券领取量
        //   couponClaimRate: "0.00%", //券领取率
        //   productName: "测试美容项目1", //商品名称
        //   sendTotal: 1, //发送次数
        //   clickRate: "0.00%", //打开率
        //   userName: "叨叨", //员工名称
        // },
      ],
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      pageSizes: [10, 20, 50, 100, 200, 500],
      title: "选择使用员工",
      dialogVisibleTree: false,
      currentSelectMember: [], //组件中要显示-选中的成员
      searchMenNames: [], //当前 搜索框-选中的成员
    };
  },
  components: { StaffTree },
  created() {
    this.getDataList();
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.tableData.doLayout();
    });
  },
  methods: {
    // 合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => item[column.property]);
        if (
          values.length > 0 &&
          index !== 5 &&
          index !== 3 &&
          index !== 8 &&
          index !== 10
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        } else if (index == 3) {
          sums[index] = `${((sums[2] / sums[1]) * 100 >= 100
            ? 100
            : (sums[2] / sums[1]) * 100
          ).toFixed(2)}%`;
        } else if (index == 5) {
          sums[index] = `${((sums[4] / sums[1]) * 100 >= 100
            ? 100
            : (sums[4] / sums[1]) * 100
          ).toFixed(2)}%`;
        } else if (index == 8) {
          sums[index] = `${((sums[7] / sums[6]) * 100 >= 100
            ? 100
            : (sums[7] / sums[6]) * 100
          ).toFixed(2)}%`;
        } else if (index == 10) {
          sums[index] = `${((sums[9] / sums[6]) * 100 >= 100
            ? 100
            : (sums[9] / sums[6]) * 100
          ).toFixed(2)}%`;
        }
      });
      // if (index === 5) {
      //   sums[index] = `${(sums[4] / sums[3]) * 100}%`;
      // }
      console.log("总计XXXXXXXX", data, columns, sums);
      return sums;
    },
    async getDataList() {
      const res = await getEmpDataList(
        this.formData,
        localStorage.getItem("Authorization")
      );
      this.tableData = res.data.rows;
      this.pageparm.total = res.data.total;
      console.log("获取表格的数据结构", res);
    },
    searchFn() {
      this.getDataList();
    },
    selectTime() {
      console.log("时间改变", this.searchSelectTime);
      this.formData.startTime = dayjs(this.searchSelectTime[0]).format(
        "YYYY-MM-DD 00:00:00"
      );
      this.formData.endTime = dayjs(this.searchSelectTime[1]).format(
        "YYYY-MM-DD 23:59:59"
      );
      this.getDataList();
    },
    formatter(row, column) {
      return row.clicks;
    },
    // 排序
    sortMethod() {},
    sortChange(val) {
      if (val.order === "ascending") {
        this.formData.sortRule = "asc";
      } else if (val.order === "descending") {
        this.formData.sortRule = "desc";
      }
      this.formData.sortField = val.prop;
      this.getDataList();
      console.log(
        "排序变化",
        this.formData,
        dayjs()
          .subtract(29, "days")
          .format("YYYY-MM-DD hh:mm:ss")
      );
    },
    // 分页回调
    callBack(parm) {
      console.log("分页器XXXX", parm);
      this.formData.currentPage = parm.currentPage;
      this.formData.pageSize = parm.pageSize;
      this.getDataList();
    },
    //打开树
    clickAddMember() {
      this.dialogVisibleTree = true;
    },
    closeTree() {
      this.dialogVisibleTree = false;
    },
    // 搜索-添加成员---清空
    searchCloseTag() {
      this.searchMenNames = [];
      this.currentSelectMember = [];
      this.formData.userIds = [];
      // this.markLength = 0
      this.formData.currentPage = 1;
      this.getDataList();
    },
    //添加人弹窗确认回调
    clickSubmitTree(val) {
      this.currentSelectMember = val.currentMember;
      this.formData.currentPage = 1;
      this.formData.userIds = [];
      // this.markLength = 0
      this.searchMenNames = val.currentIdName;
      val.sendArray.forEach((item) => {
        this.formData.userIds.push(item.userId);
      });
      this.getDataList();
      this.dialogVisibleTree = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-table {
  overflow: visible !important;
  .has-gutter{
    font-weight: 700;
  }
}
/deep/.tree-input {
  margin-right: 10px;
  width: 200px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  .el-icon-close {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 5px;
  }
}
</style>
